import { defineStore } from 'pinia';
import { CompanyServices } from '@services/company-services';
import { useInterface } from './interface-store';
import { useSession } from './session-store';

const USE_TERMS_TYPE = 'termos_e_condicoes_de_uso';

export const useTermsBannerStore = defineStore('useTermsBannerStore', {
  state: () => ({
    term: null,
    isOpen: false,
    isSubmitting: false,
    isFirstAcceptance: false,
    hasFetched: false,
  }),
  actions: {
    async fetch() {
      if (this.hasFetched) return;
      this.hasFetched = true;

      const $session = useSession();
      if (!$session.canDo('CAN_ACCEPT_PARTNER_TERMS')) return;

      try {
        const { terms } = await CompanyServices.getAllTerms();
        const useTerms = terms.filter((term) => term.term_type === USE_TERMS_TYPE);

        const pendingActiveTerm = useTerms.find((term) => term.is_active && !term.current_user_accepted);
        if (pendingActiveTerm) {
          this.term = pendingActiveTerm;
          this.isFirstAcceptance = true;
          this.isOpen = true;
          return;
        }

        // Já aceitou o termo ativo: só reabre em caso de atualização de versão (checagem por versão).
        const updatedTerm = await CompanyServices.getUseTermsBanner();
        if (updatedTerm) {
          this.term = updatedTerm;
          this.isFirstAcceptance = false;
          this.isOpen = true;
        }
      } catch (_error) {
        this.hasFetched = false;
      }
    },
    async accept() {
      if (!this.term || this.isSubmitting) return;
      this.isSubmitting = true;

      const $interface = useInterface();

      try {
        await CompanyServices.acceptTerm(this.term.id);
        this.isOpen = false;
        this.term = null;
        this.isFirstAcceptance = false;
      } catch (_error) {
        $interface.toast.add({
          label: 'Não foi possível registrar o aceite. Tente novamente.',
          color: 'danger',
        });
      } finally {
        this.isSubmitting = false;
      }
    },
  },
});
